export default {
    namespaced: true,

    state: {
        itemsTotal: 0,
        pageSizes: [],
        pageSize: 10,
        currentPage: 1,
    },

    getters: {
        pagesTotal(state) {
            return Math.ceil(state.itemsTotal / state.pageSize);
        },

    },

    mutations: {
        setItemsTotal(state, itemsTotal) {
            state.itemsTotal = itemsTotal;
        },

        setPageSizes(state, pageSizesArray) {
            state.pageSizes = pageSizesArray;
        },

        setPageSize(state, pageSize) {
            state.pageSize = pageSize;
        },

        setCurrentPage(state, page) {
            state.currentPage = page;
        },

    },

    actions: {
        setPagination({commit}, headers) {
            // res.headers

            // check if response contain the 'x-total-count' header
            if ('x-total-count' in headers) {
                const itemsTotal = +headers['x-total-count'];

                commit('setItemsTotal', itemsTotal);
            }
        },

        setPageSizes({commit, dispatch}, {pageSizes, currentSize}) {
            commit('setPageSizes', pageSizes);

            dispatch('setPageSize', currentSize);
        },

        setPageSize({state, commit, dispatch}, currentSize) {

            // toNumber
            let pageSize = +currentSize || state.pageSizes[0];

            commit('setPageSize', pageSize);

            // go to first page after the pageSize change
            dispatch('setFirstPage');
        },

        setPage({commit}, page) {

            // toNumber
            let currentPage = Math.round(+page) || 1;

            commit('setCurrentPage', currentPage);
        },

        setFirstPage({dispatch}) {
            dispatch('setPage', 1);
        },

    }
}